import { createIcon } from './_icon';

// home-open
const HomeOutlinedIcon = createIcon(() => (
	<svg width="1em" height="1em" fill="none" viewBox="0 0 24 24">
		<path stroke="currentColor" stroke-width="2" d="M20 20V9l-8-6.5L4 9v11h6v-6h4v6h6Z" />
	</svg>
));

export default HomeOutlinedIcon;
